// Чипы выбора типа блюда для экрана «Что приготовить»: витринная подпись → серверный course.
// Серверные ключи course — подмножество backend COURSES (recipes/classify.ts).
export interface CourseChip {
  course: string;
  label: string;
}

export const COURSE_CHIPS: CourseChip[] = [
  { course: 'soup', label: 'Первое' },
  { course: 'main', label: 'Второе' },
  { course: 'salad', label: 'Салат' },
  { course: 'side', label: 'Гарнир' },
  { course: 'breakfast', label: 'Завтрак' },
  { course: 'baking', label: 'Выпечка' },
];
